import "./index.css";

import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client";
import {
  DAppProvider,
  Goerli,
  Mumbai,
  AuroraTestnet,
  CronosTestnet,
  OasisEmeraldTestnet,
} from "@usedapp/core";
import "antd/dist/antd.css";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { CHAINS } from "./constants";

// Change this to your own Infura project id: https://infura.io/register
// const INFURA_PROJECT_ID = "53e706eaa088405491d1e311f6a6938b";
const config = {
  readOnlyChainId: Mumbai.chainId,
  readOnlyUrls: {
    [Mumbai.chainId]: CHAINS.Mumbai.rpcUrl,
    [Goerli.chainId]: CHAINS.Goerli.rpcUrl,
    // [CHAINS.Optimism.chainId]: CHAINS.Optimism.rpcUrl,
    // [CHAINS.Skale.chainId]: CHAINS.Skale.rpcUrl,
    [CronosTestnet.chainId]: CHAINS.Cronos.rpcUrl,
    [AuroraTestnet.chainId]: CHAINS.Aurora.rpcUrl,
    [OasisEmeraldTestnet.chainId]: CHAINS.Oasis.rpcUrl,
  },
};

// You should replace this url with your own and put it into a .env file
// See all subgraphs: https://thegraph.com/explorer/
const client = new ApolloClient({
  cache: new InMemoryCache(),
  uri: "https://api.thegraph.com/subgraphs/name/epochprotocol/epoch-base",
});

ReactDOM.render(
  <React.StrictMode>
    <DAppProvider config={config}>
      <ApolloProvider client={client}>
        <App />
      </ApolloProvider>
    </DAppProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
